export const PASSWORD_TOGGLE_MIN_LENGTH = 3;

export const PASSWORD_INPUT_TOGGLE_CLASS = "t-input pr-[4.5rem]";

export const PASSWORD_TOGGLE_BTN_CLASS =
  "absolute right-[2.65rem] top-1/2 -translate-y-1/2 text-[var(--t-meta)] hover:text-[var(--t-text)]";

export function showsPasswordToggle(value) {
  return (value || "").length >= PASSWORD_TOGGLE_MIN_LENGTH;
}

/** Eye stays visible for as long as the field has enough characters. */
export function usePasswordToggleVisibility(value) {
  return showsPasswordToggle(value);
}
